<template>
    <div class="home-content">
        <div class="email-wrap content-wrap">
            <div class="title">EMAIL:</div>
            <a class="address tag-read" :data-clipboard-text="email" @click="emailClick">{{email}}</a>
        </div>
        <div class="ins-wrap content-wrap">
            <div class="title">INSTAGRAM:</div>
            <a class="address" :href="obj.inslink">{{instagram}}</a>
        </div>

    </div>
</template>
<script>
    import Clipboard from 'clipboard';
    import { site } from '../../api'
    export default{
        name:"contact",
        data(){
            return {
                email:'',
                instagram:'',
                obj: {}
            }
        },
        methods: {
            emailClick(){
                 var clipboard = new Clipboard('.tag-read')

                clipboard.on('success', e => {
                    this.$toast.success('复制成功')
                console.log('复制成功')

                // 释放内存

                clipboard.destroy()

                })

                clipboard.on('error', e => {

                // 不支持复制

                console.log('该浏览器不支持自动复制')

                // 释放内存

                clipboard.destroy()

                })
            }
        },
        mounted(){
            site({}).then(res=>{
                let data=JSON.parse(res.data.data)
                this.email=data.email
                this.instagram=data.instagram
                console.log(data);
                this.obj = data
                // this.info = JSON.parse(res.data.data)
                
            })
        }
    }
</script>
<style scoped>
    .home-content{
        display:flex;
        align-items:center;
        justify-content: center;
        flex-direction:column;
        flex: 1;
        text-align: center;
    }
    .ins-wrap{
        margin-top:2.4rem;
    }
    .content-wrap{
        font-size: .25rem;
        font-family: Khmer Sangam MN;
        font-weight: 400;
        color: #000000;
        line-height: 1.2;
    }
    .address{
        color: #13b5b1;
        text-decoration:underline;
    }
</style>